'use client';

import { usePathname } from 'next/navigation';
import { Header } from './Header';

export function ConditionalHeader() {
  const pathname = usePathname();
  if (pathname === '/about') return null;
  if (pathname?.startsWith('/word-addin')) return null;
  if (pathname?.startsWith('/atlas')) return null; // Atlas ima lasten obraz (vizija §I.3)
  return <Header />;
}
